import { Coffee, Wallet2 } from 'lucide-react';
import React from 'react';
import { useAuth } from '../../global-components/src';
import { t } from '../../global-components/src/i18nTranslate';

const Transfer = ({ isMobile, onClick, id_user }: { isMobile?: boolean, onClick?: any, id_user: number }) => {
    const { user } = useAuth();

    return (
        <>
            {id_user != user?.id && (
                <li>
                    <ul className="ul-normal">
                        <span onClick={onClick} className="dropdown-item cursor-pointer user-select-none" {...(!isMobile ? { "data-bs-toggle": "modal", "data-bs-target": "#give-coffee" } : "")}>
                            <div className="div-icon-fix">
                                <><Coffee data-feather="paperclip" data-type="unfix" className="icon-config-post"/>{t("post.actions.sendCoffee")} </>
                            </div>
                        </span>
                    </ul>
                </li>
            )}
        </>
    );
};

export default Transfer;
